import { render, staticRenderFns } from "./quickorderWeb_child.vue?vue&type=template&id=7cb7c1c8&scoped=true"
import script from "./quickorderWeb_child.vue?vue&type=script&lang=js"
export * from "./quickorderWeb_child.vue?vue&type=script&lang=js"
import style0 from "./quickorderWeb_child.vue?vue&type=style&index=0&id=7cb7c1c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb7c1c8",
  null
  
)

export default component.exports